import { ALL, CANCEL, CANCELLED, COMPLETED, DDMMYYYY, DDMMYYYY_SLASH, ON_GOING, UP_COMING } from "./constants"
import moment from "moment"

export const emailValidateRegex =
  /^(?![.-])([a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*)@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export function isValidPassword(password) {
  let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/
  return reg.test(password)
}

export const getMonthFormattedDate = (inputDate) => {
  const date = new Date(inputDate)

  // Extract the date parts
  const month = date.toLocaleString("en-US", { month: "short" })
  const day = String(date.getDate()).padStart(2, "0")
  const year = date.getFullYear()

  return `${month}-${day}-${year}`
}

export const getFormattedDate = (inputDate) => {
  return moment(inputDate).format(
    DDMMYYYY_SLASH
  )
}

export function getFirstChars(names) {
  return names.reduce((acc, name) => acc + " " + name?.[0]?.toUpperCase(), "")
}

export function getTime(date) {
  return new Date(date)
    .toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true })
    .toUpperCase()
}

export function getRandomColor() {
  var letters = "0123456789ABCDEF"
  var color = "#"
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)]
  }
  return color
}

export function getFullName(obj) {
  let fullName = ""
  if (obj?.firstName) {
    fullName = obj.firstName
  }
  if (obj?.lastName) {
    fullName += " " + obj.lastName
  }
  return fullName
}

export function getColor(status) {
  let color = "#ffc107"
  status = status.toLowerCase()
  if (status === ALL.toLowerCase()) {
    color = "#fff"
  } else if (status === COMPLETED.toLowerCase()) {
    color = "#28a745"
    } else if (status === ON_GOING.toLowerCase()) {
      color = "#007bff"
    } else if (status === CANCEL.toLowerCase() || status === CANCELLED.toLowerCase()) {
      color = "red"
    }
  return color
}

export function getBaseUrl() {
  const isLocal = window.location?.hostname?.includes('localhost')
  const BASE_URL = isLocal ? "http://localhost:5008" : "https://api.ayrshireeyeclinic.com";
  return BASE_URL
}

export function getBaseStorageUrl() {
  const baseUrl = getBaseUrl()
  return baseUrl + "/storage"
}